import React from 'react';

import ArticleCard from '../ArticleCard';
import EventCard from '../EventCard';
import type { RelatedContentHit } from './types';

const renderRelatedHit = (hit: RelatedContentHit): React.ReactElement => {
  if (
    hit.type[0] === 'event'
    && hit.event_date
    && hit.event_date_end_value
    && hit.computed_first_upcoming_date_index
  ) {
    const index = hit.computed_first_upcoming_date_index[0];
    const rawStart = hit.event_date[index];
    const rawEnd = hit.event_date_end_value[index];

    /**
     * Apend +00:00 to the date registration.
     * We do this because the dates we receive from the API are stored in UTC.
     * By appending +00:00 we can handle them as such.
     */
    const startDate = rawStart ? new Date(`${rawStart}+00:00`) : null;
    const endDate = rawEnd ? new Date(`${rawEnd}+00:00`) : null;
    const timezone = hit.event_date_timezone?.[index];

    return (
      <EventCard
        link={hit.url[0]}
        title={hit.page_title[0]}
        image={hit.image_style_uri?.[0]}
        startDate={startDate}
        endDate={endDate}
        timezone={timezone}
        hasMultipleDates={hit.event_date_infinite?.includes(true) || hit.event_date.length > 1}
      />
    );
  }

  return (
    <ArticleCard
      link={hit.url[0]}
      title={hit.page_title[0]}
      subtitle={hit.body_summarized?.[0]}
      image={hit.image_style_uri?.[0]}
      readTime={hit.read_time?.[0]}
      publicationDate={new Date(hit.created[0])}
    />
  );
};

export default renderRelatedHit;
